import { h, Component } from 'preact';
import Hero from '../hero/hero';
import About from '../about/about';
import Products from '../products/products';
import Contact from '../contact/contact';
import Footer from '../footer/footer';

export default class Home extends Component {
  render() {
    return (<div>
      <Hero />
      <About />
      <Products />
      <Contact />
      <Footer />
    </div>);
  }
}



// WEBPACK FOOTER //
// ./components/home/home.jsx